import { render, staticRenderFns } from "./host-set-pro-category.vue?vue&type=template&id=90ad2296&scoped=true&"
import script from "./host-set-pro-category.vue?vue&type=script&lang=js&"
export * from "./host-set-pro-category.vue?vue&type=script&lang=js&"
import style0 from "./host-set-pro-category.vue?vue&type=style&index=0&id=90ad2296&scoped=true&lang=scss&"
import style1 from "./host-set-pro-category.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ad2296",
  null
  
)

export default component.exports